module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/postcode.js
// module id = 841
// module chunks = 0